const DEFAULT_LOCALE = 'en-GB';

const SCRIPT_ID = 'MewsScript';

const SCRIPT_URL = 'https://app.mews.com/payment-checkout/checkout.js';

const SUPPORTED_LOCALES = [
  'cs-CZ',
  'da-DK',
  'de-CH',
  'de-DE',
  'el-GR',
  'en-GB',
  'en-US',
  'es-ES',
  'et-EE',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'is-IS',
  'it-IT',
  'ja-JP',
  'ka-GE',
  'ko-KR',
  'lv-LV',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'sk-SK',
  'sv-SE',
  'tr-TR',
  'uk-UA',
];

export { DEFAULT_LOCALE, SCRIPT_ID, SCRIPT_URL, SUPPORTED_LOCALES };
